// extracted by mini-css-extract-plugin
export default {"container":"Lba-z","productName":"Mba-z","price":"Nba-z","dimensions":"Oba-z"};